import { Typography } from '@material-ui/core';
import { COLORS } from 'components/twilio/constants';
import TRANSLATIONS from 'components/twilio/translations';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ChatInterfaceContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`;

const ErrorText = styled(Typography)`
  max-width: 70%;
  color: ${COLORS.ERROR};
  font-family: Lato, san-serif;
  text-align: center;
`;

const ChatInterfaceFallback: FC = () => {
  const { t } = useTranslation();
  return (
    <ChatInterfaceContainer>
      <ErrorText variant="body1">
        {t(...TRANSLATIONS.ERRORS.RENDER)}
      </ErrorText>
    </ChatInterfaceContainer>
  );
};

export default ChatInterfaceFallback;
